module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "amap",
      "title": "Map"
    }
  }, [_c('figure', [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "map1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxiii",
      "title": "xxiii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Map 1. The Oneida Nation of Indians...",
      "height": "480",
      "src": "images/map1.jpg",
      "width": "451"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_vm._v("Map 1. The Oneida Nation of Indians of Wisconsin Today. In 1838, Oneida treaty lands were 65,540 acres, most of which were lost as a result of federal allotment policies between 1887 and 1933. In 2017, the Wisconsin Oneidas had 25,329 acres—14,481 acres of trust lands and 11,048 of tribal fee simple lands. Map by Laurence M. Hauptman."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxiv",
      "title": "xxiv"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26cfced8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253041401_Map.vue
// module id = 87
// module chunks = 0